import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

// appsetup - Get All (Read)
export const GetAllDashboard = createAsyncThunk(
  "/admin/dashboard",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Dashboard.dashboard}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetAllUserWallet = createAsyncThunk(
  "/admin/user-wallet",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Dashboard.dashboard}/wallet-history`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const Slice = createSlice({
  name: "dashboard",
  initialState: {
    data: {},
    user_wallet: {},

    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetAppSetUp, AddAppSetUp, UpdateAppSetUp, DeleteAppSetUp
      .addCase(GetAllDashboard.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllDashboard.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data || {};
      })
      .addCase(GetAllDashboard.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetAllUserWallet.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllUserWallet.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.user_wallet = action.payload?.data || {};
      })
      .addCase(GetAllUserWallet.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
